
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useToken } from '../../project';

import appGetActions from '../saga';
import RootAnonymous from './RootAnonymous';
import RootLogin from './RootLogin';
import RootLogged from './RootLogged';

const Root = (props) => {

    const dispatch = useDispatch();
    const appActions = appGetActions(dispatch);

    useEffect(() => {
        const projectId = props.project.split(':')[0];
        appActions.setProjectId(projectId);
    }, []);

    const token = useToken();
    const loading = useSelector(state => {
        return state.auth.loading;
    });

    if (props.anonymous === true) {
        return <RootAnonymous {...props} />
    } else {
        if (!loading && (!token)) {
            return <RootLogin {...props} />
        } else {
            return <RootLogged {...props} />
        }
    }
}

export default Root;
